import { useState, useEffect } from "react"
import { MOBILE_WIDTH_MAX } from "@/constants"

const useWindowSize = () => {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  })
  const isMobile = windowSize.width < MOBILE_WIDTH_MAX

  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      })
    }

    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  return { width: windowSize.width, height: windowSize.height, isMobile }
}

export default useWindowSize
